import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyMember} from '../../../graphql/groups.datatypes';
import {gqlRoomPartyMember} from '../../GroupBookings/getGroupBooking.api';

export interface CreateRoomPartyMemberInput {
    data: {
        room_party_id: number
        group_member_id: number
        primary_occupant: boolean
        billing_party_id: number
        guest_number: number
        start_date: string
        end_date: string
    }
}

interface CreateRoomPartyMemberData {
    createRoomPartyMember: RoomPartyMember
}

export const CREATE_ROOM_PARTY_MEMBER_MUTATION = gql`
    mutation createRoomPartyMember($data: CreateRoomPartyMemberInput!) {
        createRoomPartyMember(data: $data) {
            ${gqlRoomPartyMember}
        }
    }
`;

export const createRoomPartyMember = () => useMutation<CreateRoomPartyMemberData, CreateRoomPartyMemberInput>(
    CREATE_ROOM_PARTY_MEMBER_MUTATION,
    {
        update: updateCacheByType('RoomPartyMember'),
    }
);

export default createRoomPartyMember;